import { CellContext } from '@tanstack/react-table'
import { formatRelativeTimeAndDate } from '@/utils/formatRelativeTimeAndDate'
import { formatDateForTable } from '@/utils/formatDateForTable'

export const formatDateCell = ({ cell }: CellContext<unknown, unknown>) => {
    const value = cell.getValue()
    return value ? formatDateForTable(value as string) : undefined
}

export const formatRelativeTimeAndDateCell = ({
    cell,
}: CellContext<unknown, unknown>) => {
    const value = cell.getValue()
    return value ? formatRelativeTimeAndDate(value as string) : undefined
}
